'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CaseStudyQuote } from '@/components/case-study/case-study-quote';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const CookingLifeCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="CookingLife"
        title={t.customerStories['cookinglife_hero_title']}
        subtitle={t.customerStories['cookinglife_what_we_did']}
        stats={[
          {
            value: isRTL ? '٧٠٪' : '70%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? '+مليون' : '1M+',
            label: t.customerStories['Customers served'],
          },
          {
            value: isRTL ? '+١٠ آلاف' : '10K+',
            label: t.customerStories['Products in catalog'],
          },
        ]}
        videoSrc="/home/features/cookinglife.mp4"
        videoVariant="ambient"
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-cookinglife.svg',
          logoAlt: 'CookingLife',
          company: t.customerStories['cookinglife_company_description'],
          industry: t.customerStories['E-commerce / Retail'],
          websiteUrl: 'https://www.cookinglife.nl',
          keyResults: [
            t.customerStories['• 70% automation rate (cookinglife)'],
            t.customerStories['• Under 1 minute response time'],
            t.customerStories['• 1M+ customers served'],
            t.customerStories['• 10,000+ products covered'],
          ],
        }}
      >
        <p>{t.customerStories['cookinglife_intro']}</p>

        <h2>{t.customerStories['cookinglife_challenge_title']}</h2>
        <p>{t.customerStories['cookinglife_challenge_p1']}</p>
        <p>{t.customerStories['cookinglife_challenge_p2']}</p>

        <h2>{t.customerStories['cookinglife_solution_title']}</h2>
        <p>{t.customerStories['cookinglife_solution_p1']}</p>
        <p>{t.customerStories['cookinglife_solution_p2']}</p>
        <p>{t.customerStories['cookinglife_solution_p3']}</p>

        <h2>{t.customerStories['cookinglife_automation_title']}</h2>
        <p>{t.customerStories['cookinglife_automation_intro']}</p>
        <ul>
          <li>
            <strong>{t.customerStories['Order Management']}</strong>{' '}
            {t.customerStories['cookinglife_automation_orders']}
          </li>
          <li>
            <strong>{t.customerStories['Product Expertise']}</strong>{' '}
            {t.customerStories['cookinglife_automation_products']}
          </li>
          <li>
            <strong>{t.customerStories['Inventory Integration']}</strong>{' '}
            {t.customerStories['cookinglife_automation_inventory']}
          </li>
        </ul>
        <p>{t.customerStories['cookinglife_automation_escalation']}</p>

        <CaseStudyQuote
          quote={[
            t.customerStories['cookinglife_quote_p1'],
            t.customerStories['cookinglife_quote_p2'],
            t.customerStories['cookinglife_quote_p3'],
          ]}
          attribution={t.customerStories['cookinglife_quote_attribution']}
        />

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['cookinglife_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '+٧٠٪' : '70%+',
            },
            {
              metric: t.customerStories['Avg response time'],
              impact: isRTL ? 'أقل من دقيقة' : '<1 min',
            },
            {
              metric: t.customerStories['CSAT score'],
              impact: isRTL ? '+٤,٥ نجوم' : '4.5+ stars',
            },
            {
              metric: t.customerStories['Products in catalog'],
              impact: isRTL ? '+١٠ آلاف' : '10,000+',
            },
          ]}
        />

        <h2>{t.customerStories['cookinglife_impact_title']}</h2>
        <p>{t.customerStories['cookinglife_impact_p1']}</p>
        <p>{t.customerStories['cookinglife_impact_p2']}</p>
        <p>{t.customerStories['cookinglife_impact_p3']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default CookingLifeCaseStudy;
